import {DateTime} from 'luxon';
import {
  RemoteAvailableClientSetting,
  RemoteClientSettingValue,
  RemoteClientSettingUpdate,
  AvailableClientSetting,
  ClientSettingValue,
  ClientSettingUpdate,
} from './clientSettings.types';

function toClientAvailableClientSetting(
  remote: RemoteAvailableClientSetting,
): AvailableClientSetting {
  return {
    key: remote.key,
    uiName: remote.uiName,
    uiOrder: remote.uiOrder,
    description: remote.description,
    category: remote.category,
    controlledBy: remote.controlledBy,
    appliedFor: remote.appliedFor,
    visibleForClient: remote.visibleForClient,
    type: remote.type,
    valueConstraints: {
      defaultValue: remote.valueConstraints.defaultValue,
      stringOptions: remote.valueConstraints.stringOptions ?? null,
      stringMaxLength: remote.valueConstraints.stringMaxLength ?? null,
      minValue: remote.valueConstraints.minValue ?? null,
      maxValue: remote.valueConstraints.maxValue ?? null,
      allowMultiple: remote.valueConstraints.allowMultiple ?? false,
    },
    nestedUnderSettingKey: remote.nestedUnderSettingKey,
    legalDisclaimer: remote.legalDisclaimer,
    allowedUsers: remote.allowedUsers ?? null,
  };
}

function toClientClientSettingValue(remote: RemoteClientSettingValue): ClientSettingValue {
  return {
    clientId: remote.clientId,
    settingKey: remote.settingKey,
    value: remote.value,
    type: remote.type,
    updatedBy: remote.updatedBy,
    updatedTime: DateTime.fromISO(remote.updatedTime),
  };
}

function toRemoteClientSettingUpdate(client: ClientSettingUpdate): RemoteClientSettingUpdate {
  return {
    key: client.key,
    value: client.value,
  };
}

export {toClientAvailableClientSetting, toClientClientSettingValue, toRemoteClientSettingUpdate};

